import React from "react";
import Group53 from "../../assets/1 our.webp";
import Group51 from "../../assets/3 orange.webp";
import Group52 from "../../assets/2 Purple.webp";
import Group54 from "../../assets/4 cyan.webp";
import Grid from "../../assets/Grid.png";

import consistentTrips from '../../assets/internalImages/Driver Partner/_wpwp_consistent_trip.webp'
import allInOneDriver from '../../assets/internalImages/Driver Partner/_wpwp_all_in_one_drive_app.webp'
import HigherEarnings from '../../assets/internalImages/Driver Partner/_wpwp_higher_earnings.webp'
import OnTimePayments from '../../assets/internalImages/Driver Partner/_wpwp_on_time_payment.webp'

const DriverSection2 = () => {
  return (
    <div className="py-5" style={{ backgroundImage: `url(${Grid})` }}>
      <div className="container">
      <h1 className="fw-200 fs-2 fs-md-2 fs-lg-1 text-center">
              Why Partner With Packky
            </h1>
            <p className="m-0 p-0 text-muted mb-5 text-center" >
             Drive your future further with benefits, flexibilikty and real earnings.
            </p>
        <div className="row align-items-center mb-4">
          <div className="col-md-6 text-md-start text-center service-card-67">
            <h3 className="fw-bold" style={{fontSize:"24px"}}>Consistent Trips</h3>
            <p className="fs-5 text-secondary mt-3">
            Packky's expanding network across multiple cities ensures a steady flow of delivery requests. You stay active with consistent trips throughout the day. 
            </p>
          </div>
          <div className="col-md-6 text-center">
          <img src={consistentTrips} className="img-fluid rounded" style={{ maxHeight: "350px" }} alt="Real Time Order Tracking" />
          </div>
        </div>

        <div className="row align-items-center mb-4 flex-md-row-reverse">
          <div className="col-md-6 text-md-start text-center service-card-67">
            <h3 className="fw-bold" style={{fontSize:"24px"}}>All-in-One Driver App</h3>
            <p className="fs-5 text-secondary mt-3">
          Access trips, manage deliveries, track your income, and reach support anytime with our simple and feature-packed driver app build for a smooth experience. 
            </p>
          </div>
          <div className="col-md-6 text-center">
            <img src={allInOneDriver} className="img-fluid rounded" style={{ maxHeight: "350px" }}alt="Smart Route Optimization" />
          </div>
        </div>

        <div className="row align-items-center mb-4">
          <div className="col-md-6 text-md-start text-center service-card-67">
            <h3 className="fw-bold" style={{fontSize:"24px"}}>Higher Earnings</h3>
            <p className="fs-5 text-secondary mt-3">
            Partnet with a platform designed to boost your income. HIgh demand and efficient trip allocation help you complete more orders and earn more.
            </p>
          </div>
          <div className="col-md-6 text-center">
            <img src={HigherEarnings} className="img-fluid rounded" style={{ maxHeight: "350px" }}alt="Driver Management" />
          </div>
        </div>

        <div className="row align-items-center mb-4 flex-md-row-reverse">
          <div className="col-md-6 text-md-start text-center service-card-67">
            <h3 className="fw-bold" style={{fontSize:"24px"}}>On-Time Paymnet</h3>
            <p className="fs-5 text-secondary mt-3">
           We value your work and time. Packky ensures timely payments directly to your account with complete transparency and no delays. 
           </p>
          </div>
          <div className="col-md-6 text-center">
            <img src={OnTimePayments} className="img-fluid rounded" style={{ maxHeight: "350px" }}alt="Customer Notifications" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DriverSection2;
